<template>
    <RightClickMenu
        class="pre-login-language-selector"
        :menuContent="menuContent"
        @action="selectLanguage"
    >
        <div class="flex-row">
            <p class="smoked" style="margin-right: 6px">
                {{ $t('LABEL_APP_LANGUAGE') }}
            </p>
            <img
                class="pre-login-flag"
                :src="require(`@/${languageIcon}`)"
                alt=""
            />
        </div>
    </RightClickMenu>
</template>
<script>
import { languageOptions } from '@/helpers/Language'
export default {
    props: {
        availableLanguages: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        menuContent() {
            const content = languageOptions.map(option => {
                const object = {
                    event: option.key,
                    display: option.display
                }
                if (option && option.icon) {
                    object.specialIcon = option.icon
                }
                return object
            })
            return this.availableLanguages.length > 0
                ? content.filter(option =>
                      this.availableLanguages.includes(option.event)
                  )
                : content
        },
        languageIcon() {
            const lang = languageOptions.find(o => o.key == this.$i18n.locale)
            return lang ? lang.icon : 'assets/img/flags/united-kingdom.svg'
        }
    },
    methods: {
        selectLanguage(lang) {
            this.$Language.selectLanguage(lang)
            this.$store.commit('setSelectedLanguage', lang)
        }
    }
}
</script>
<style lang="scss" scoped>
.pre-login-language-selector {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: $input;

    div {
        @include button-hover;
    }
}
.pre-login-flag {
    height: 1.5rem;
    margin-left: 0.2rem;
    margin-top: -0.2rem;
}
</style>
